import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  PoDynamicFormField,
  PoNotificationService,
} from '@po-ui/ng-components';
import { countries } from 'src/app/constants/countries';
import { states } from 'src/app/constants/states'; // Importar os estados fixos
import { tenantIdFromLink } from 'src/app/utils/rc4-crypt';
import { environment } from 'src/environments/environment';
import { HttpService } from './../../services/http.service';
import { ViaCepService } from './../../services/via-cep.service';

@Component({
  selector: 'card-token',
  templateUrl: './card-token.component.html',
  styleUrls: ['./card-token.component.scss'],
})
export class CardTokenComponent implements OnInit {
  label: string = '';
  cardToken: any = {
    cardNumber: '',
    cardholderName: '',
    securityCode: '',
    expirationMonth: '',
    expirationYear: '',
    country: 'BR',
    state: '',
  };

  tokenMail = {};

  error: any;
  success: any;

  showCVV: boolean = false;

  countries = countries;

  states = states;

  fieldsContract: Array<PoDynamicFormField> = [
    {
      property: 'ZAM_CONTRT',
      label: 'Número',
      gridMdColumns: 2,
      gridSmColumns: 12,
      order: 1,
      disabled: true,
    },
    {
      property: 'B1_DESC',
      label: 'Plano',
      gridMdColumns: 4,
      gridSmColumns: 12,
      order: 2,
      disabled: true,
    },
    {
      property: 'ZAM_VLTOT',
      label: 'Valor',
      gridMdColumns: 3,
      gridSmColumns: 12,
      order: 3,
      type: 'currency',
      disabled: true,
    },
  ];

  fieldsCC: Array<PoDynamicFormField> = [];
  fieldsBillingAddress: Array<PoDynamicFormField> = [];
  fieldsContact: Array<PoDynamicFormField> = [];

  lWaiting = true;
  saving = false;

  textWaiting = '';
  message = '';

  dataContract = {
    A1_NOME: '',
    ZAM_CONTRT: '',
    B1_DESC: '',
    ZAM_VLTOT: 0,
    A1_EMAIL: '',
  };

  isHideLoading = true;
  textEnviar = 'Cadastrando cartão...';

  constructor(
    private service: HttpService,
    private viaCepService: ViaCepService,
    public poNotification: PoNotificationService,
    private active: ActivatedRoute
  ) {}

  async ngOnInit() {
    this.active.queryParams.subscribe(async (params) => {
      const { link } = params;
      let tokenValidate = null;

      this.tokenMail = { link };

      if (link) {
        const tenantId = tenantIdFromLink(link, environment.cryptKey);
        this.service.setTenantId(tenantId);

        try {
          tokenValidate = await this.validToken();
        } catch (error) {
          console.error(error);
          // Ignorar erro de validação do token
        }
      } else {
        // Ignorar a validação do token e exibir o formulário
        this.error = {
          message: 'Dados do cliente e/ou token não enviado(s)',
          img: 'error',
        };
      }

      this.label = `${this.dataContract.A1_NOME}`;
      this.lWaiting = false; // Exibir o formulário independentemente da validação do token

      this.setFieldsCC();
      this.setFieldsAddress();
      this.setFieldsContact();
    });
  }

  setFieldsCC = () => {
    this.fieldsCC = [
      {
        property: 'cpf',
        required: true,
        label: 'CPF *',
        pattern: '[0-9]',
        mask: '999.999.999-99',
        placeholder: '999.999.999-99',
        minLength: 14,
        maxLength: 14,
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
      },
      {
        property: 'cardholderName',
        required: true,
        label: 'Nome no Cartão *',
        placeholder: 'Nome',
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
      },
      {
        property: 'cardNumber',
        required: true,
        label: 'Número do Cartão *',
        pattern: '[0-9]',
        mask: '9999 9999 9999 9999',
        placeholder: '9999 9999 9999 9999',
        minLength: 19,
        maxLength: 19,
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
      },
      {
        property: 'securityCode',
        required: true,
        label: 'CVV *',
        placeholder: 'CVV',
        pattern: '[0-9]',
        minLength: 3,
        maxLength: 3,
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
      },
      {
        property: 'expirationMonth',
        required: true,
        label: 'Mês de Validade *',
        placeholder: 'MM',
        pattern: '[0-9]',
        mask: '99',
        minLength: 2,
        maxLength: 2,
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
      },
      {
        property: 'expirationYear',
        required: true,
        label: 'Ano de Validade *',
        placeholder: 'AAAA',
        pattern: '[0-9]',
        mask: '9999',
        minLength: 4,
        maxLength: 4,
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
      },
    ];
  };

  setFieldsAddress = () => {
    this.fieldsBillingAddress = [
      {
        property: 'zipCode',
        required: true,
        label: 'CEP *',
        pattern: '[0-9]',
        mask: '99999-999',
        placeholder: '00000-000',
        minLength: 9,
        maxLength: 9,
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
        validate: this.buscarCep.bind(this),
      },
      {
        property: 'address',
        required: true,
        label: 'Logradouro *',
        placeholder: 'Rua/Av',
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
      },
      {
        property: 'number',
        required: true,
        label: 'Número *',
        placeholder: 'Número',
        pattern: '[0-9]',
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
      },
      {
        property: 'city',
        required: true,
        label: 'Cidade *',
        placeholder: 'Cidade',
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
      },
      {
        property: 'state',
        required: true,
        label: 'Estado *',
        placeholder: 'Selecione um Estado',
        options: this.states,
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
      },
      {
        property: 'country',
        required: true,
        label: 'País *',
        placeholder: 'Selecione um País',
        options: this.countries,
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
        validate: this.onCountryChange.bind(this),
      },
    ];
  };

  setFieldsContact = () => {
    this.fieldsContact = [
      {
        property: 'email',
        required: true,
        label: 'E-mail *',
        type: 'e-mail',
        placeholder: 'seu@email.com',
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
      },
      {
        property: 'phone',
        required: true,
        label: 'Telefone *',
        pattern: '[0-9]',
        mask: '(99) 99999-9999',
        placeholder: '(00) 0000-0000',
        minLength: 15,
        maxLength: 15,
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
      },
    ];
  };

  updateFieldsVisibility() {
    this.fieldsContract = [
      {
        property: 'ZAM_CONTRT',
        label: 'Número',
        gridMdColumns: 2,
        gridSmColumns: 12,
        order: 1,
        disabled: true,
        visible: !!this.dataContract.ZAM_CONTRT, // Agora é um booleano direto
      },
      {
        property: 'B1_DESC',
        label: 'Plano',
        gridMdColumns: 4,
        gridSmColumns: 12,
        order: 2,
        disabled: true,
      },
      {
        property: 'ZAM_VLTOT',
        label: 'Valor',
        gridMdColumns: 3,
        gridSmColumns: 12,
        order: 3,
        type: 'currency',
        disabled: true,
        visible: !!this.dataContract.ZAM_VLTOT, // Agora é um booleano direto
      },
    ];
  }

  validToken = async () => {
    this.lWaiting = true;
    this.textWaiting = 'Validando o token';

    try {
      const { data } = await this.service.post(
        'validarTokenMail',
        this.tokenMail
      );

      this.textWaiting = '';
      this.lWaiting = false;

      this.dataContract = data;

      if (this.dataContract.A1_NOME) {
        this.message = `${this.dataContract.A1_NOME}`;
      }

      if (this.dataContract.A1_EMAIL) {
        this.cardToken = {
          ...this.cardToken,
          email: this.dataContract.A1_EMAIL,
        };
      }

      // Atualiza os campos para definir a visibilidade dinamicamente
      this.updateFieldsVisibility();

      return data;
    } catch (error: any) {
      console.error('Erro no validToken:', error);

      // Se for erro 401, tentar renovar o token
      if (error.status === 401) {
        try {
          // Limpar token atual e tentar obter um novo
          this.service.clearToken();
          const { data } = await this.service.post(
            'validarTokenMail',
            this.tokenMail
          );

          this.textWaiting = '';
          this.lWaiting = false;

          this.dataContract = data;

          if (this.dataContract.A1_NOME) {
            this.message = `${this.dataContract.A1_NOME}`;
          }

          if (this.dataContract.A1_EMAIL) {
            this.cardToken = {
              ...this.cardToken,
              email: this.dataContract.A1_EMAIL,
            };
          }

          return data;
        } catch (retryError: any) {
          console.error('Erro na segunda tentativa:', retryError);
          this.error = retryError;
          this.error['img'] = 'expired';
          this.lWaiting = false;
          return false;
        }
      }

      this.error = error;
      this.error['img'] = 'expired';
      this.lWaiting = false;
      return false;
    }
  };

  buscarCep(event: any) {
    const cep = event.value.replace(/\D/g, '');

    if (cep.length === 8) {
      this.viaCepService.getAddressByCep(cep).subscribe(
        (data: any) => {
          if (!data.erro) {
            this.cardToken.address = data.logradouro;
            this.cardToken.city = data.localidade;
            this.cardToken.state = data.uf;

            // Atualizar o formulário dinamicamente
            this.fieldsBillingAddress = this.fieldsBillingAddress.map(
              (field) => {
                if (field.property === 'address') {
                  return { ...field, value: data.logradouro };
                } else if (field.property === 'city') {
                  return { ...field, value: data.localidade };
                } else if (field.property === 'state') {
                  return { ...field, value: data.uf };
                }
                return field;
              }
            );
          } else {
            this.poNotification.warning('CEP não encontrado.');
          }
        },
        (error) => {
          this.poNotification.error('Erro ao buscar o CEP.');
        }
      );
    }
  }

  onCountryChange(event: any) {
    const selectedCountry = event.value;
    const stateFieldIndex = this.fieldsBillingAddress.findIndex(
      (field) => field.property === 'state'
    );

    if (selectedCountry === 'BR') {
      this.fieldsBillingAddress[stateFieldIndex] = {
        property: 'state',
        required: true,
        label: 'Estado *',
        placeholder: 'Selecione um Estado',
        options: this.states,
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
        type: 'select',
      };
    } else {
      this.fieldsBillingAddress[stateFieldIndex] = {
        property: 'state',
        required: true,
        label: 'Estado *',
        placeholder: 'Digite o Estado',
        gridXlColumns: 6,
        gridLgColumns: 6,
        gridMdColumns: 6,
        gridSmColumns: 12,
        clean: true,
        type: 'string',
      };
    }

    this.cardToken.state = '';

    this.fieldsBillingAddress = [...this.fieldsBillingAddress];
  }

  send = async () => {
    this.saving = true;

    this.isHideLoading = false;

    try {
      const result = await this.service.post('salvarToken', {
        card: { ...this.cardToken, storageCard: '0' },
        tokenMail: {
          ...this.tokenMail,
          ZAM_CONTRT: this.dataContract['ZAM_CONTRT'],
        },
      });

      console.log('result', result);

      this.success = {
        message: 'Cartão de crédito cadastrado com sucesso',
        img: 'success',
      };
    } catch (error) {
      console.log('error', error);

      if (error instanceof HttpErrorResponse) {
        this.poNotification.error(
          'Erro ' + (error as HttpErrorResponse).error.errorMessage
        );
      } else {
        this.poNotification.error('Erro ao cadastrar o cartão');
      }
    }
    this.saving = false;

    this.isHideLoading = true;
  };

  close = () => {
    window.close();
  };

  clear = () => {
    this.cardToken = {
      cardNumber: '',
      cardholderName: '',
      securityCode: '',
      expirationMonth: '',
      expirationYear: '',
      country: 'BR',
      state: '',
      zipCode: '',
      address: '',
      number: '',
      city: '',
      email: '',
      phone: '',
      cpf: '',
    };

    // Para garantir que o formulário dinâmico seja atualizado
    this.fieldsCC = [...this.fieldsCC];
    this.fieldsBillingAddress = [...this.fieldsBillingAddress];
    this.fieldsContact = [...this.fieldsContact];
  };

  validPreSend = () =>
    this.fieldsCC.every(
      ({ required, property }) => !required || this.cardToken[property]
    ) &&
    this.fieldsBillingAddress.every(
      ({ required, property }) => !required || this.cardToken[property]
    ) &&
    this.fieldsContact.every(
      ({ required, property }) => !required || this.cardToken[property]
    );

  getCardFocus(): string {
    const {
      cardholderName,
      cardNumber,
      securityCode,
      expirationMonth,
      expirationYear,
    } = this.cardToken;

    if (this.showCVV) {
      return 'cvc';
    }

    if (securityCode.length > 0 && securityCode.length < 3) {
      return 'cvc';
    }

    if (
      securityCode.length === 3 &&
      (!cardholderName || !cardNumber || !expirationMonth || !expirationYear)
    ) {
      return '';
    }

    return '';
  }

  toggleCardSide(event: any) {
    this.showCVV = event;
  }

  formatExpiry(month: string, year: string): string {
    if (month || year) {
      const formattedMonth = month.padStart(2, '0');
      const formattedYear = year.slice(-2);
      return `${formattedMonth}${formattedYear}`;
    }
    return '';
  }
}
